module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"play_level_victory_modal_loaded","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"levelSlug":{"type":"string","maxLength":128}},"required":["user","levelSlug"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/play_level_victory_modal_loaded.json
// module id = 560
// module chunks = 100